import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import { memo } from "react";
import { useInView } from "react-intersection-observer";

type OnwardLinksESIProps = {
  currentUrl: string;
  onwardLinkType: string | undefined;
  handleMonetateActions: () => void;
  threshold: number;
};

export const OnwardLinksESI = memo(
  ({
    currentUrl,
    onwardLinkType,
    handleMonetateActions,
    threshold,
  }: OnwardLinksESIProps) => {
    const esiSrc = `/esi/foundit?productUrl=${currentUrl}&onwardLinkType=${onwardLinkType}`;

    const { ref } = useInView({
      threshold: threshold,
      triggerOnce: true,
      onChange: (inView) => {
        if (inView) {
          handleMonetateActions();
        }
      },
    });

    return (
      <div id="onward-links-wrapper" ref={ref}>
        {onwardLinkType && <ESIInclude id="onward-links-esi" src={esiSrc} />}
      </div>
    );
  },
  () => true,
);

OnwardLinksESI.displayName = "MemoedOnwardLinksESI";
